import Swal from "sweetalert2";
// import { useNavigate } from 'react-router-dom';

// export const handleUnauthorized = () => {
//   const navigate = useNavigate();
//   localStorage.removeItem("authToken");
//   Swal.fire({
//     icon: "error",
//     title: "Session expired. Please login again.",
//     toast: true,
//     position: "top-end",
//     showConfirmButton: false,
//     timer: 2000,
//   });
//   navigate('/login');
// };

// Session keys mirror SignInLayer's SESSION_KEYS: it writes them to BOTH
// storages, so both must be cleared here. Leaving the sessionStorage copy
// made /sign-in bounce straight back to /dashboard on a stale token —
// a 401 redirect loop fast enough to trip the per-IP rate limit and lock
// the operator out of signIn itself with 429s.
const SESSION_KEYS = [
  "authToken",
  "name",
  "admin_id",
  "profile_picture",
  "user_role",
  "permissions",
];

// Re-entrancy guard: every mounted component that gets a 401 calls this at
// the same moment; only the first should toast and navigate.
let unauthorizedHandling = false;

export const handleUnauthorized = (navigate) => {
  if (unauthorizedHandling) return;
  unauthorizedHandling = true;
  setTimeout(() => {
    unauthorizedHandling = false;
  }, 3000);

  SESSION_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  localStorage.removeItem("lastActivityTime");
  localStorage.removeItem("sessionHeartbeat");

  Swal.fire({
    icon: "error",
    title: "Session expired. Please login again.",
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
  navigate("/sign-in");
};

export const showSuccessMessage = (successmessage) => {
  Swal.fire({
    icon: "success",
    title: `${successmessage}`,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
};

export const showErrorMessage = (errormessage) => {
  Swal.fire({
    icon: "error",
    title: `${errormessage}`,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
};

export const showConfirmationDialog = async (
  message,
  confirmmessage = "Yes, change it!",
  cancelMessage = "No, keep it"
) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: `${message}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: `${confirmmessage}`,
    cancelButtonText: `${cancelMessage}`,
  });
  return result;
};

export const showInfoDialog = async (title, message) => {
  return Swal.fire({
    icon: "info",
    title: title || "Info",
    text: message,
    confirmButtonText: "OK",
  });
};

export const showRejectWithEditOption = async (reason) => {
  const result = await Swal.fire({
    icon: "warning",
    title: "AI Review Rejected ❌",
    text: reason || "This question needs fixing.",
    showCancelButton: true,
    confirmButtonText: "Go to Edit",
    cancelButtonText: "Close",
  });
  return result;
};
